import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../../context/auth";
import {logout} from "../../services/auth-service";
import React, {useRef, useState} from "react";
import {AppRoutes} from "../../utils/constants";
import UserAvatar from "../../components/user-avatar";
import useDetectOutsideClickHook from "../../modules/useDetectOutsideClick";
import {Nav} from "react-bootstrap";

function NavbarProfile(props) {

  const navigate = useNavigate();
  const auth = useAuth();
  const [collapsed, setCollapsed] = useState(true);

  const navProfileMenu = useRef(null);
  useDetectOutsideClickHook(navProfileMenu, ()=>{setCollapsed(true)});

  const doLogout = ()=>{
    logout().finally(()=>{
      auth.doLogout();
      navigate(AppRoutes.landing.path);
    })
  };

  return (
    <div ref={navProfileMenu}>
      <a className="nav-link dropdown-toggle nav-user arrow-none me-0"
         id="topbar-userdrop"
         role="button"
         aria-haspopup="true"
         aria-expanded={!collapsed}
         onClick={(event)=>setCollapsed(!collapsed)}>
        <span className="account-user-avatar">
          {auth.currentUser ? <UserAvatar user={auth.currentUser} /> :
            <span className={"bg-white rounded-circle p-1 d-flex align-items-center justify-content-center"} style={{"width":"30px", "height":"30px", "overflow": "hidden"}}>
            <span className="dripicons-user text-dark" style={{"fontSize": "25px", "position": "relative"}}></span>
          </span>}
        </span>
        <span>
          <span className="account-user-name">{auth.currentUser?.name} {auth.currentUser?.surname}</span>
          <span className="account-position">{auth.currentUser?.trainer ? 'FitPro' : ''}</span>
        </span>
      </a>
      <div className={`dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown ${collapsed ? '' : ' show'}`} aria-labelledby="topbar-userdrop">

        {process.env.REACT_APP_DEBUG==='true' && <span className="dropdown-item notify-item px-3 py-2 nav-link d-flex flex-column align-items-start bg-secondary-subtle">
          <div>v{process.env.REACT_APP_VERSION}</div>
          <div><i className="mdi mdi-api me-1"></i>
            {process.env.REACT_APP_BASE_API_URL.toString().includes('https://api.sweatnow.com') && <span className="badge bg-danger text-white">PROD</span>}
            {process.env.REACT_APP_BASE_API_URL.toString().includes('https://testapi.sweatnow.com') && <span className="badge bg-primary text-white">TEST</span>}
            {process.env.REACT_APP_BASE_API_URL.toString().includes('localhost') && <span className="badge bg-primary text-white">DEV</span>}
            </div>
            <div><i className="mdi mdi-cash me-1"></i> {process.env.REACT_APP_STRIPE_PK.toString().includes('pk_test') ? <span className="badge bg-primary text-white">TEST</span> : <span className="badge bg-danger text-white">PROD</span>}</div>
        </span>}

        <Nav.Link as={Link} eventKey={6} to={AppRoutes.profile.path} className="dropdown-item notify-item clickable px-3 py-2" onClick={() => setCollapsed(!collapsed)}>
          <i className="mdi mdi-account-circle me-1"></i>
          <span>Profile</span>
        </Nav.Link>

        {auth.currentUser?.trainer && <Nav.Link as={Link} eventKey={7} to={`${AppRoutes.trainers.path}/${auth.currentUser.id}`} className="dropdown-item notify-item clickable px-3 py-2" onClick={() => setCollapsed(!collapsed)}>
          <i className="mdi mdi-whistle-outline me-1"></i>
          <span>FitPro Profile</span>
        </Nav.Link>}

        {/*<a href="javascript:void(0);" className="dropdown-item notify-item">*/}
        {/*  <i className="mdi mdi-account-edit me-1"></i>*/}
        {/*  <span>Nastavenia</span>*/}
        {/*</a>*/}

        <span className="dropdown-item notify-item clickable px-3 py-2 nav-link" onClick={() => {
          setCollapsed(!collapsed);
          doLogout()
        }}>
          <i className="mdi mdi-logout me-1"></i>
          <span>Logout</span>
        </span>

      </div>
    </div>
  );
}

export default NavbarProfile
